/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/sources" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSources } from "./constants";
import type { CDISource } from "./types";
import { isCdiSourcesResult } from "./validators";

export const getIntegrationsDirectCdiSources = reactQueryFetcherAdapter(
  integrationsDirectCdiSources,
  (signal: AbortSignal): Promise<CDISource[]> => {
    return fetch("/integrations/direct/cdi/sources", "GET", {}, { signal });
  },
  isCdiSourcesResult
);
